export const TOGGLE_MOBILE_DRAWER_LEFT_SIDEBAR =
  'editorAC/DemoHomePageContainer/TOGGLE_MOBILE_DRAWER_LEFT_SIDEBAR';
